import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useSpecificPageLink } from './useSpecificPageLink';
import { useCustomRouteMatch } from '../../../hooks/useCustomRouteMatch';
import { contentAPIPrefixSelector } from '../../../redux/reducers/app/configuration';
import {
  brandSelector,
  channelSelector,
  languageSelector,
} from '../../../redux/reducers/app/params';
import { getPageParams, getMetaPageLink } from '../utils';
import { CHANNEL_CONFIG_MAP, ENTITY, QUERY } from '../../../constants/content';
import { EXCLUDED_ROUTES_FOR_SEO_TEXT } from '../../../constants/SEOConfig';

export const useSEOTextRequestUrl = () => {
  const { path, params } = useCustomRouteMatch();
  const pageParams = useMemo(() => getPageParams(path, params), [path, params]);

  const contentAPIPrefix = useSelector(contentAPIPrefixSelector);
  const brand = useSelector(brandSelector);
  const channel = useSelector(channelSelector);
  const language = useSelector(languageSelector);

  const specificPageLink = useSpecificPageLink();

  return useMemo(() => {
    const commonPageLink = getMetaPageLink(path);

    const searchParams = new URLSearchParams({
      [QUERY.CHANNEL]: CHANNEL_CONFIG_MAP[channel.toUpperCase()],
      [QUERY.BRANDS]: brand,
      [QUERY.LANGUAGE_NAME]: language,
      [QUERY.PAGE]: commonPageLink,
      ...pageParams,
    });

    if (specificPageLink) {
      searchParams.append(QUERY.PAGE, specificPageLink);
    }

    const isDisabled = EXCLUDED_ROUTES_FOR_SEO_TEXT.includes(path);

    // Return null for preventing making request
    return isDisabled
      ? null
      : `${contentAPIPrefix}/${ENTITY.SEO_TEXTS}?${searchParams}`;
  }, [
    path,
    channel,
    brand,
    language,
    pageParams,
    specificPageLink,
    contentAPIPrefix,
  ]);
};
